<template>

  <div>
    <div>
      <img src="../assets/banner.png" style="width: 100%;"/>
    </div>
    <div class="form_list">
      <div class="input_box">
        <div class="input_label">1.姓名</div>
        <van-field placeholder="请输入姓名" v-model="form.name"/>
      </div>
      <div class="input_box">
        <div class="input_label">2.性别</div>
        <van-radio-group v-model="form.sex">
          <van-radio name="男">男</van-radio>
          <van-radio name="女" style="margin-top:0.5rem;">女</van-radio>
        </van-radio-group>
      </div>
      <div class="input_box">
        <div class="input_label">3.出生年月</div>
        <van-field placeholder="点击选择出生年月日" :readonly="true" :value="form.birthday"
                   @click="showBirthDay = true"/>
      </div>
      <div class="input_box">
        <div class="input_label">4.疾病名称</div>
        <van-field placeholder="请输入疾病名称" v-model="form.types"/>
      </div>
      <div class="input_box">
        <div class="input_label">5.请选择院区</div>
        <van-radio-group v-model="form.area" @change="radioChange">
          <van-radio name="体育新城">体育新城院区</van-radio>
          <van-radio name="希望广场" style="margin-top:0.5rem;">希望广场院区</van-radio>
        </van-radio-group>
      </div>
      <div class="input_box">
        <div class="input_label">6.请选择预约住院的具体日期</div>
        <div class="pop_box" @click="pop_show_change" v-show="current_data_index === -1" style="color:#909399">等待排床
        </div>
        <div class="pop_box" @click="pop_show_change" v-show="form.orderDate==undefined && current_data_index !== -1"
             style="color:#909399">请选择预约日期
        </div>
        <div class="pop_box" @click="pop_show_change" v-show="form.orderDate!=undefined && form.orderDate!=''">
          {{ form.orderDate }}
        </div>
      </div>
      <div class="input_box">
        <div class="input_label">7.协助您本次填写预约信息的医生是</div>
        <select v-model="form.doctor">
          <option style="display: none;" :value="undefined">请选择</option>
          <option v-for="(item,index) in doctorList" :value="item.Id" :key="index">{{ item.realName }}</option>
        </select>
      </div>
      <div class="input_box">
        <div class="input_label">8.家长电话或联系方式</div>
        <van-field placeholder="请输入家长电话或联系方式" v-model="form.phone"/>
      </div>
      <div class="input_box">
        <div class="input_label">9.床位需求</div>
        <select v-model="form.room">
          <option value="普通三人间">普通三人间</option>
        </select>
      </div>
      <div>
        <van-button type="info" style="width: 100%;" v-if="loading==false" @click="submit_it">提交信息</van-button>
        <van-button loading type="info" style="width: 100%;" loading-text="加载中..." v-else></van-button>
      </div>
    </div>
    <bed-choose :area="form.area" ref="bedChoose" @onChoose="onChooseArea"/>
    <van-popup
      v-model="showBirthDay"
      position="bottom"
    >
      <van-datetime-picker type="date" v-model="currentDate" :min-date="minDate" @confirm="birthdayConfirm"/>
    </van-popup>
  </div>

</template>


<style scoped>
.form_list {
  width: 90%;
  padding: 5%;
}

.input_box {
  width: 100%;
  margin-bottom: 1rem;
}

.input_label {
  padding: 0.5rem 0;
}

.input_box select {
  width: 100%;
  border: 1px solid #909399;
  padding: 10px 16px;
  outline: none;
  background: transparent;
  font-size: 1rem;
  color: #909399;
  border-radius: 0;
}

.pop_box {
  width: calc(100% - 16px);
  border: 1px solid #909399;
  height: 2.5rem;
  display: flex;
  align-items: center;
  padding-left: 16px;
  /*justify-content: center;*/
}

.data_list {
  width: calc(100% - 1.6rem);
  padding: 0.8rem;

}

.data_check_box {
  width: 100%;
  overflow-y: scroll;
  height: 55vh;
  /*justify-content: center;*/
}

.data_box {
  padding: 0.8rem 0.2rem;
  margin-right: 2%;
  margin-bottom: 0.5rem;
  box-sizing: border-box;
  width: 31%;
  text-align: center;
  border: 1px solid #909399;
  float: left;
  height: 120px;
}

.data_box_select {
  background: #f1fedb;
}

/deep/ .van-cell {
  border: 1px solid #909399;
}

/deep/ .van-radio {
  border: 1px solid #909399;
  padding: 10px 16px;
}

.empty_box {
  width: 100%;
  line-height: 300px;
  text-align: center;
}
</style>

<script>
import moment from 'moment'
import BedChoose from '@/components/BedChoose'

export default {
  beforeCreate: function () {

  },
  components: {
    BedChoose
  },
  data() {
    return {
      showBirthDay: false,
      currentDate: new Date(2002, 1, 1),
      loading: false,
      config: {
        waiBed: []
      },
      form: {
        name: undefined,
        sex: '男',
        area: '体育新城',
        age: undefined,
        month: undefined,
        types: undefined,
        room: '普通三人间',
        doctor: undefined,
        orderDate: undefined,
        phone: undefined,
        openid: undefined,
        birthday: undefined
      },
      pop_show: false,
      current_data_index: undefined,
      current_data: undefined,
      dataList: [],
      doctorList: [],
      minDate: new Date(2002, 1, 1),
      maxDate: new Date()
    }
  },
  created: function () {

  },
  mounted: function () {
    this.getConfig();
    this.pre_submit();
    this.get_doctor();
  },
  watch: {
    'form.area': function (n, o) {
      this.pre_submit();
    }
  },
  methods: {
    radioChange(v) {
      this.form.orderDate = null
      this.pop_show = false;
    },
    birthdayConfirm(item) {
      var choose_date = moment(item);
      var current_date = moment();
      var diff_months = current_date.diff(choose_date, 'months');
      var years = current_date.diff(choose_date, 'years');
      var months = diff_months % years
      this.form.birthday = moment(item).format('YYYY-MM-DD')
      this.form.age = years
      this.form.month = months || 1
      this.showBirthDay = false
    },
    pop_show_change() {
      if (this.pop_show === true) {
        this.pop_show = false
        this.$refs['bedChoose'].onShow()
      } else {
        this.pop_show = true
        this.$refs['bedChoose'].onHide()
      }

    },
    check_data(i) {
      console.log(i)
      this.current_data_index = i;
    },
    confirm_data() {
      if (this.current_data_index === -1) {
        this.form.orderDate = null
        this.pop_show = false;
      } else {
        this.form.orderDate = this.dataList[this.current_data_index].reserve_date
        this.pop_show = false;
      }
    },
    onChooseArea({
                   orderDate,
                   current_data_index
                 }) {
      this.form.orderDate = orderDate
      this.current_data_index = current_data_index
    },
    pre_submit() {
      let self = this;
      this.$http.post('/client/schedule', {
        area: this.form.area
      }).then(function (response) {
        if (response.data.code === 0) {
          self.dataList = response.data.data
        } else {
          self.$toast.fail(response.data.msg);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    getConfig() {
      let self = this;
      this.$http.post('/client/config', {}).then(function (response) {
        if (response.data.code === 0) {
          self.config = response.data.data
        } else {
          self.$toast.fail(response.data.msg);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    get_doctor() {
      let self = this;
      this.$http.post('/client/doctor', {
        area: this.form.area
      }).then(function (response) {
        console.log(response)
        if (response.data.code === 0) {
          self.doctorList = response.data.data
          if (self.doctorList.length > 0) {
            self.form.doctor = -1
          }
        } else {
          self.$toast.fail(response.data.msg);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    submit_it() {
      let self = this;
      if (this.dataList.length > 0) {
        if (!this.form.orderDate || this.form.orderDate === '') {
          return self.$toast.fail('请选择日期');
        }
      }
      this.loading = true;
      if (self.form.name === undefined || self.form.name === '') {
        self.$toast.fail('请填写姓名');
        self.loading = false
      } else if (self.form.sex === undefined || self.form.sex === '') {
        self.$toast.fail('请选择性别');
        self.loading = false
      } else if (self.form.birthday === undefined || self.form.birthday === '') {
        self.$toast.fail('请选择孩子的生日');
        self.loading = false
      } else if (self.form.types === undefined || self.form.types === '') {
        self.$toast.fail('请填写诊断名称');
        self.loading = false
      } else if (self.form.doctor === undefined || self.form.doctor === '') {
        self.$toast.fail('请选择医生');
        self.loading = false
      } else if (self.form.orderDate === undefined || self.form.orderDate === '') {
        self.$toast.fail('请选择日期');
        self.loading = false
      } else if (self.form.phone === undefined || self.form.phone === '' || self.form.phone.length < 11) {
        self.$toast.fail('请填写正确手机号');
        self.loading = false
      } else {
        let copyDate = JSON.parse(JSON.stringify(self.form))
        let doctorData = this.doctorList.filter(sub => {
          return sub.Id === copyDate.doctor
        })
        copyDate['doctor_name'] = doctorData[0].realName
        copyDate['openid'] = window.localStorage.getItem('f_open_id')
        this.$http.post('/client/submit', copyDate).then(function (response) {
          if (response.data.code === 0) {
            self.$toast.success('提交成功');
            self.loading = false;
            self.$router.replace({
              name: 'process'
            })
          } else {
            self.$toast.fail(response.data.msg);
            self.loading = false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }


    },

  }
}


</script>





// WEBPACK FOOTER //
// src/views/index.vue